import { useState, useEffect } from "react";
import { Modal, Button, Group, Text, Checkbox, Stack,Radio } from "@mantine/core";

const ModalKnownUser = ({ opened, onClose, knownMails, accept, sendingMail, sendedMail, esReincorporacion, onCorregirDni }) => {

  const [data, setData] = useState(knownMails);
  const [checked, setChecked] = useState(null); 
  const [mailSentSuccessfully, setMailSentSuccessfully] = useState(false);
  
  // Verificar si ya se envió un mail al cargar el componente
  useEffect(() => {
    const mailSent = sessionStorage.getItem('mailSentSuccessfully');
    if (mailSent === 'true') {
      setMailSentSuccessfully(true);
    }
  }, []);

  // Verificar si el modal debe abrirse automáticamente
  useEffect(() => {
    const mailSent = sessionStorage.getItem('mailSentSuccessfully');
    if (mailSent === 'true' && !opened) {
      // Si ya se envió un mail pero el modal no está abierto, abrirlo
      // Esto requiere que el componente padre maneje esta lógica
    }
  }, [opened]);
  
  const handleConfirm = async () => {
    const result = await accept(checked);
    if (result) {
      setMailSentSuccessfully(true);
      sessionStorage.setItem('mailSentSuccessfully', 'true');
    }
  };

  const maskEmail = (email) => {
    const [localPart, domain] = email.split('@');
    if (!localPart || !domain) return email; // Validación básica
    
    // Mostrar primeros y últimos 3 caracteres del nombre antes del @
    const visibleStart = localPart.slice(0, 3);
    const visibleEnd = localPart.slice(-3);
    
    const maskedLocalPart = `${visibleStart}*****${visibleEnd}`;
    
    return `${maskedLocalPart}@${domain}`;
  };

  return (
    <Modal 
      opened={opened} 
      centered 
      withCloseButton={false}
      closeOnEscape={false}
      closeOnClickOutside={false}
      withinPortal={true}
      overlayProps={{
        opacity: 0.55,
        blur: 4,
      }}
    >
      { !mailSentSuccessfully ? (
        <>
          <Stack>
            {esReincorporacion ? (
              <>
                <Text ta={'center'} fw={500} size="lg">Ya tenés un legajo en esta carrera</Text>
                <Text>Detectamos que ya estuviste inscripto en esta carrera, por lo que tu inscripción
    se gestiona como una <b>reincorporación</b>. Para validar tu identidad, te enviaremos a tu
    correo registrado el link para completar la solicitud de reincorporación.</Text>
              </>
            ) : (
              <>
                <Text ta={'center'} fw={500} size="lg">¡Hola! Te reconocimos en nuestro sistema</Text>
                <Text>Vamos a completar tus datos con la información que ya tenemos para que sea más rápido.
    Solo te pediremos validar tu identidad mediante un correo electrónico y así podrás seguir con el proceso.</Text>
              </>
            )}
          </Stack>
          <Radio.Group
            value={checked}
            onChange={setChecked}
            label="Correos disponibles"
            mt={'md'}
          >
            <Stack pt="md" gap="xs">
              {knownMails?.map((mail, index) => {
                return (
                  <Radio.Card
                    className={'checkbox-card-root'}
                    radius="md"
                    key={index} // Deshabilita si es el único marcado
                    value={mail}
                  >
                    <Group wrap="nowrap" align="flex-start">
                      <Radio.Indicator color="#f20a61" disabled={sendingMail || sendedMail}/>
                      <div>
                        <Text className={'checkbox-card-label'} style={{ wordBreak: 'break-all', overflowWrap: 'anywhere' }}>{maskEmail(mail)}</Text>
                      </div>
                    </Group>
                  </Radio.Card>
                );
              })}
            </Stack>
          </Radio.Group>
          <Group justify='flex-end' wrap="nowrap" mt={'xl'}>
            {esReincorporacion && onCorregirDni && (
              <Button size="compact-md" variant="default" disabled={sendingMail} onClick={onCorregirDni}>Corregir DNI</Button>
            )}
            <Button size="compact-md" color="#f20a61" loading={sendingMail} disabled={!checked} onClick={handleConfirm}>{esReincorporacion ? 'Enviarme el link' : 'Validar identidad'}</Button>
          </Group>
        </>
      ):(
        <Stack align="center" justify="center" gap="md" py="xl">
          <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="32" fill="#e6f9f0"/>
            <path d="M20 33l8 8 16-16" stroke="#27ae60" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Text size="lg" fw={700} ta="center" c="#27ae60">
            ¡Correo enviado exitosamente!
          </Text>
          <Text ta="center" c="dimmed">
            {esReincorporacion
              ? <>Te enviamos un correo con el link para gestionar tu reincorporación. Por favor revisá tu casilla y seguí las instrucciones desde ahí.<br /></>
              : <>Te enviamos un correo para continuar con la preinscripción. Por favor revise su correo y siga las instrucciones<br /></>}
          </Text>
          <Text size="xs" ta="center" c="dimmed">
            * <b>En caso de no recibirlo</b>, verificar el correo en el apartado de no deseados
          </Text>
        </Stack>
      )}
    </Modal>
  );
};

export default ModalKnownUser;
